'use client';
import React, { useMemo, useState, useEffect } from 'react';
import {
  Box,
  Button,
  Container,
  Flex,
  Skeleton,
  Text,
} from '@chakra-ui/react';
import NextLink from 'next/link';
//Components
import { useNoticiasSwiffy } from 'hooks/noticiasHooks';
import { isAuthenticated } from 'middlewares/auth';
import { SwiffyNewsSlider } from 'components/common/SwiffySlider';
//Style
import { JoinUsSectionStylesSwiffy } from 'styles/homeStyles';

const CarouselSkeleton = React.memo(() => (
  <Box 
    {...JoinUsSectionStylesSwiffy.skeleton}
  />
));

const JoinUsSection = () => {
  const [isAuth, setIsAuth] = useState<boolean | null>(null);

  useEffect(() => {
    setIsAuth(isAuthenticated());
  }, []);

  const { noticias, isLoading } = useNoticiasSwiffy();

  const staticContent = useMemo(() => (
    <Box {...JoinUsSectionStylesSwiffy.boxContent}>
      <Text {...JoinUsSectionStylesSwiffy.title} as='h1'>
        A AAJUMP é de todos nós.
      </Text>
      <Text {...JoinUsSectionStylesSwiffy.title} as='h1'>
        Uma entidade que existe para dar voz aos analistas jurídicos.
      </Text>
      <Text {...JoinUsSectionStylesSwiffy.description}>
        Comprometida com a valorização da categoria, a AAJUMP atua para fortalecer direitos,
        promover o reconhecimento profissional.
      </Text>
    </Box>
  ), []);



  const memberButton = useMemo(() => (
    !isAuth && (
      <NextLink href="/conta/cadastro" prefetch={false}>
        <Button 
          {...JoinUsSectionStylesSwiffy.button} 
          size='lg' 
          aria-label="Torne-se um membro da comunidade"
        >
          Tornar-se membro
        </Button>
      </NextLink>
    )
  ), [isAuth]);

  const mobileButton = useMemo(() => (
    !isAuth && (
      <NextLink href="/conta/cadastro" prefetch={false}>
        <Button 
          {...JoinUsSectionStylesSwiffy.mobileButton} 
          size='lg' 
          aria-label="Torne-se um membro da comunidade"
        >
          Tornar-se membro
        </Button>
      </NextLink>
    )
  ), [isAuth]);

  const renderSliderContent = () => {
    if (isLoading) {
      return <CarouselSkeleton />;
    }
    
    if (!noticias || noticias.length === 0) {
      return (
        <Box {...JoinUsSectionStylesSwiffy.boxNoNews}>
          <Text {...JoinUsSectionStylesSwiffy.noNewsText}>
            Nenhuma notícia disponível no momento.
          </Text>
        </Box>
      );
    }

    return (
      <Box {...JoinUsSectionStylesSwiffy.boxSlider}>
        <SwiffyNewsSlider noticias={noticias} />
      </Box>
    );
  };

  return (
    <Box 
      {...JoinUsSectionStylesSwiffy.container}
      position="relative"
      width="100%"
      overflow="hidden"
    >
      <Flex {...JoinUsSectionStylesSwiffy.flexContainer}>
        <Box {...JoinUsSectionStylesSwiffy.boxContent}>
          {staticContent}
          {memberButton}
        </Box>
        <Flex {...JoinUsSectionStylesSwiffy.flexContent} mb={!isAuth ? "0" : "6"}>
          {renderSliderContent()}
        </Flex>

        {mobileButton}
      </Flex>
    </Box>
  );
};

export default React.memo(JoinUsSection);
